import React from "react";
import "../component/Footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer">
      <div className="footer-col col-one">
        <h3 className="name-footer">Pijush </h3>
        <p className="name-footer">Ray Mondal</p>
        <p className="light-lext mar-sp">
          &copy;&nbsp;2022,Build and designed by
        </p>
        <p className="light-lext">Pijush Ray Mondal</p>
      </div>
      <div className="footer-col col-two">
        <p className="font-re">Links</p>
        <div className="links">
          <div className="liks-row-one">
            <Link to="about">
              <p>About</p>
            </Link>
            <Link to="/">
              <p>Blog</p>
            </Link>
          </div>
          <div className="liks-row-one">
            {" "}
            <Link to="project">
              <p>Projects</p>
            </Link>
            <Link to="/">
              <p>Contact</p>
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-col col-three">
        <p className="font-re">Get in touch</p>
        <ul className="get-icon-link">
          <a href="https://www.linkedin.com/in/pijush-ray-mondal-621980192/">
            <li>
              <i class="fa-brands fa-github"></i>
            </li>
          </a>
          <a href="https://github.com/PIJUSH364">
            <li>
              <i class="fa-brands fa-linkedin"></i>
            </li>
          </a>
          <a href="/">
            <li>
              <i class="fa-brands fa-twitter"></i>
            </li>
          </a>
        </ul>
      </div>
    </div>
  );
}

export default Footer;
